/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { networkGetNetworkWxdomain } from "../../funcs/networkGetNetworkWxdomain.js";
import { GetNetworkWxdomainRequest$zodSchema } from "../../models/getnetworkwxdomainop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetNetworkWxdomainRequest$zodSchema,
};

export const tool$networkGetNetworkWxdomain: ToolDefinition<typeof args> = {
  name: "network-get-network-wxdomain",
  description: `检查域名在微信中的访问状态

准备在微信里推广你的网站？最好先检查一下域名是否被“拉黑”了。

## 功能概述
这个接口可以帮你查询一个域名在微信内置浏览器中的访问状态，即是否被微信封禁。这对于做微信生态推广和营销的开发者来说至关重要。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await networkGetNetworkWxdomain(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
